$(document).ready(function () {

    if ($(window).width() > 768) {
        var numberOfMonthsResponsive = 2;
    } else {
        var numberOfMonthsResponsive = 1;
    }

    if (age == undefined){var age = 18;}

    //for dept and return reservations
    $('.deptCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function(dateText){
            $(".returnCalendar").datepicker('option', 'minDate', dateText);
        },
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker")
        }
    });
    $('.returnCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.deptCalendar').val(),
        showButtonPanel: !0,
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker")
        }
    });


    //for just shamsi dept and return reservations
    $('.shamsiDeptCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function(dateText){
            $(".shamsiReturnCalendar").datepicker('option', 'minDate', dateText);
        },
    });
    $('.shamsiReturnCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.shamsiDeptCalendar').val(),
        showButtonPanel: !0,
    });


    //for just shamsi dept and return hotel reservations
    $('.shamsiDeptCalendarForHotel').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".shamsiReturnCalendarForHotel").datepicker('option', 'minDate', dateText);
        }
    });
    $('.shamsiReturnCalendarForHotel').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.shamsiDeptCalendarForHotel').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDate = new Date($('.shamsiDeptCalendarForHotel').val());
            var endDate = new Date(dateTextReturn);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForHotelLocal').html(dayDiff);
            $('#NightsForHotelLocal').attr("value", dayDiff);
        }
    });


    //for shamsi and gregorian dept and return hotel reservations
    $('.deptCalendarForHotel').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".returnCalendarForHotel").datepicker('option', 'minDate', dateText);
        },
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker")
        }
    });
    $('.returnCalendarForHotel').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.deptCalendarForHotel').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDate = new Date($('.deptCalendarForHotel').val());
            var endDate = new Date(dateTextReturn);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForForeignHotelLocal').html(dayDiff);
            $('#NightsForForeignHotelLocal').attr("value", dayDiff);
        },
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker")
        }
    });


    //for just gregorian dept and return reservations
    $('.gregorianDeptCalendar').datepicker({
        regional: '',
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function(dateText){
            $(".gregorianReturnCalendar").datepicker('option', 'minDate', dateText);
        },
    });
    $('.gregorianReturnCalendar').datepicker({
        regional: '',
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.gregorianDeptCalendar').val(),
        showButtonPanel: !0,
    });


    //for shamsi birthday
    $('body').delegate('.shamsiBirthdayCalendar','focus', function(e) {
        $(this).datepicker({
            maxDate: 'Y/M/D',
            showButtonPanel: !0,
            changeMonth: true,
            changeYear: true,
            yearRange: '1300:1480'
        });
    });


    //for adults shamsi birthday
    $('.shamsiAdultBirthdayCalendar').datepicker({
        maxDate: '-12Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for childs shamsi birthday
    $('.shamsiChildBirthdayCalendar').datepicker({
        minDate: '-12Y',
        maxDate: '-2Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for infants shamsi birthday
    $('.shamsiInfantBirthdayCalendar').datepicker({
        minDate: '-2Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for -12 shamsi birthday
    $('.shamsiUnder12BirthdayCalendar').datepicker({
        minDate: '-12Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for gregorian birthday
    $('.gregorianBirthdayCalendar').datepicker({
        regional: '',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for adults gregorian birthday
    $('.gregorianAdultBirthdayCalendar').datepicker({
        regional: '',
        maxDate: '-12Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for childs gregorian birthday
    $('.gregorianChildBirthdayCalendar').datepicker({
        regional: '',
        minDate: '-12Y',
        maxDate: '-2Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for infants gregorian birthday
    $('.gregorianInfantBirthdayCalendar').datepicker({
        regional: '',
        minDate: '-2Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for -12 gregorian birthday
    $('.gregorianUnder12BirthdayCalendar').datepicker({
        regional: '',
        minDate: '-12Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for driver (min age To Rent) shamsi birthday
    $('.shamsiDriverBirthdayCalendar').datepicker({
        maxDate: '-' + age + 'Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for driver (min age To Rent) gregorian birthday
    $('.gregorianDriverBirthdayCalendar').datepicker({
        regional: '',
        maxDate: '-' + age + 'Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for shamsi with no limit
    $('.shamsiNoLimitCalendar').datepicker({
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for gregorian with no limit
    $('.gregorianNoLimitCalendar').datepicker({
        regional: '',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for shamsi from today
    $('.shamsiFromTodayCalendar').datepicker({
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for gregorian from today
    $('.gregorianFromTodayCalendar').datepicker({
        regional: '',
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for shamsi range one month
    $('.shamsiRangeFirstCalendar').datepicker({
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480',
        onSelect: function (dateText) {

            var newDate = new Date(dateText);
            newDate.setDate(newDate.getDate() + 31);
            if (newDate.getMonth() == 10) {
                var dd = newDate.getDate();
                var mm = newDate.getMonth() - 9;
                var y = newDate.getFullYear() + 1;
            } else {
                var dd = newDate.getDate();
                var mm = newDate.getMonth() + 1;
                var y = newDate.getFullYear();
            }
            var formattedDate = y + '-' + mm + '-' + dd;

            $('.shamsiRangeSecondCalendar').datepicker({
                minDate: dateText,
                maxDate: formattedDate,
                changeMonth: true,
                changeYear: true,
                yearRange: '1300:1480'
            });
        }
    });

});